import axios from "axios";
import { BaseApiDomain } from "../env";
import {
  clearAuthUserData,
  getSessionBearerToken,
  stripStoredAuthToken,
} from "../Utils/authSession";

stripStoredAuthToken();

const BaseApi = (ApiEndPoint = null) => {
  if (ApiEndPoint == null) {
    const user = JSON.parse(localStorage.getItem("userData"));
    if (user && user.panel == "costcenter") {
      ApiEndPoint = "costcenter";
    } else if (user && user.panel == "staff") {
      ApiEndPoint = "staff";
    }
  }
  const client = axios.create({
    baseURL: BaseApiDomain + ApiEndPoint,
    withCredentials: true,
  });

  client.interceptors.request.use(
    (config) => {
      const token = getSessionBearerToken();
      if (token) {
        config.headers["Authorization"] = "Bearer " + token;
      }
      config.headers["Content-Type"] = "application/json";
      config.headers["Accept"] = "application/json";
      return config;
    },
    (error) => {
      console.log(error);
    }
  );

  client.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        const onAuthPage =
          typeof window !== "undefined" &&
          (window.location.pathname === "/" ||
            window.location.pathname.includes("login") ||
            window.location.pathname.includes("forgot-password"));
        clearAuthUserData();
        if (!onAuthPage && typeof window !== "undefined") {
          window.location.replace("/");
        }
      }
      return Promise.reject(error);
    }
  );

  return client;
};

export default BaseApi;
